import { type Maybe } from '@amazon/vinyl-util'

export enum TransitionKeys {
    MAIN_IMAGE = 'mainImage',
}

export function prepareViewTransition(target: HTMLElement, key: TransitionKeys, id: Maybe<string>) {
    const name = getViewTransitionName(key, id)
    // Ensure no other element has the same transition name.
    const previousEl: HTMLElement | null = document.querySelector(
        `[style*="view-transition-name: ${name}"]`
    )
    previousEl?.style.removeProperty('view-transition-name')
    target.style.setProperty('view-transition-name', name)
}

export function getViewTransitionName(key: TransitionKeys, id: Maybe<string>) {
    return `${key}-${id}`
}
